module.exports = __webpack_public_path__ + "img/2.bf6ce3e0.png";